export enum UserRole {
  USER = 'user',
  STAFF = 'staff',
  SUPERUSER = 'superuser'
}

export const UserRoleTitle = {
  [UserRole.USER]: 'Viewer',
  [UserRole.STAFF]: 'Editor',
  [UserRole.SUPERUSER]: 'Superuser',
};